export default class WebUI 
{
    constructor()
    {
        
        this.modalOverlay = document.getElementById('modal-overlay');
        
        this.modalHeader = document.getElementById('modal-header');
        
        this.openModalButton = document.getElementById('open-modal');
        this.sectionsContainer = document.getElementById('modal-sections-container');
        
        this.loadingScreen = document.getElementById('loading-screen');
        this.visualLoadBar = document.getElementById('visual-bar-fill');
        this.visualLoadBar.style.height = '0%';
        
        this.modalIsOpen = false;

        this.modalSectionTemplate = document.getElementById('modal-section-template');
        this.modalSectionVideoTemplate = document.getElementById('modal-section-video-template');
        this.modalSectionVideoCtaTemplate = document.getElementById('modal-section-video-cta-template');
        
        this.modalOverlay.addEventListener('click', (event) => {
            if(event.target === this.modalOverlay) {
                this.closeModal();
            }
        });
    }

    showModal(data)
    {
        this.modalHeader.innerText = `Drop ${data.info.dropNumber}`;
        // this.modalDescription.innerHTML = data.info.description;
        this.modalOverlay.classList.add('active');

        // Clear out any existing sections before adding new ones
        this.sectionsContainer.innerHTML = '';

        data.info.sections?.forEach(section => {
            //this.addSection(section);
            this.addSectionFromTemplate(section);
        });
        
        this.modalIsOpen = true;
    }

    addSectionFromTemplate(sectionData)
    {
        let sectionTemplate;
        let sectionVisual;
        let imageLink;
        let ctaButton;

        if(sectionData.type === 'video') { //VIDEO
            sectionTemplate = this.modalSectionVideoTemplate.content.cloneNode(true);
            sectionVisual = sectionTemplate.querySelector('video');
            sectionVisual.src = sectionData.video_url;
        } else if(sectionData.type === 'video-cta') { //VIDEO CTA
            sectionTemplate = this.modalSectionVideoCtaTemplate.content.cloneNode(true);
            sectionVisual = sectionTemplate.querySelector('video');
            sectionVisual.src = sectionData.video_url;
            ctaButton = sectionTemplate.querySelector('button');
            ctaButton.id = sectionData.cta.id;
            ctaButton.addEventListener('click', () => {
                window.open(sectionData.cta.url, '_blank');
            });
            ctaButton.innerText = sectionData.cta.name;
        } else { //IMAGE
            sectionTemplate = this.modalSectionTemplate.content.cloneNode(true);
            sectionVisual = sectionTemplate.querySelector('img');
            sectionVisual.src = sectionData.image_url;
            imageLink = sectionTemplate.querySelector('a');
            
            if(sectionData.image_link) {
                imageLink.href = sectionData.image_link;
            }
        }

        const sectionName = sectionTemplate.querySelector('h1');
        const sectionDescription = sectionTemplate.querySelector('p');
        
        sectionName.innerText = sectionData.name;
        sectionDescription.innerHTML = sectionData.description;
        
        this.sectionsContainer.appendChild(sectionTemplate);
    }

    closeModal()
    {
        // Stop all videos in the modal
        const videos = this.sectionsContainer.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();
            video.currentTime = 0; 
        });

        this.modalOverlay.classList.remove('active');
        this.modalIsOpen = false;
    }

}